/**
 * Created with IntelliJ IDEA.
 * User: danielr
 * Date: 6/3/14
 * Time: 9:45 AM
 * To change this template use File | Settings | File Templates.
 */


define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseModel = require("models/BaseModel");
    var LEResourceResolver = require("leResourceResolver");

    var DataSourcesCountModel = {};
    LE.module("LEManager", function (LEManager, LE, Backbone, Marionette, $, _) {

        DataSourcesCountModel = BaseModel.extend({
            apiResource: LEResourceResolver.apiResources.DataAgent.DataSourcesCount,
            name: "DataSourcesCountModel",
            resource: function() {
                var params = {
                    timeFrame: this.timeFrame,
                    metricsArr: this.metricType
                };
                return LEResourceResolver.extendResourceWithOptions.call(this, this.apiResource, params);
            },
            defaults: {
                dataMetrics: []
            },

            initialize: function (options) {

                this.timeFrame = options.timeFrame || 1440;
                this.metricType = options.metricType;

                LEManager.logger.debug("DataSourcesCountModel:initialize - ended");

            },

            fetchCount: function (options) {
                this.fetch({
                    success: function (data) {
                        if(options.success && _.isFunction(options.success)){
                            options.success(data, options);
                        }
                    },
                    error: function (model, resp) {
                        LEManager.logger.error("DataSourcesCountModel:fetchCount:error: " + resp);
                        if(options.error && _.isFunction(options.error)){
                            options.error(model, options);
                        }
                    }

                });
            },

            parse: function (resp, options) {
                var that = this;

                if (resp && resp.dataMetrics) {
                    that.set("dataMetrics", resp.dataMetrics);
                }
                else {
                    LEManager.logger.error("DataSourcesCountModel:parse:Bad response: " + resp);
                    LEManager.logger.graph({name: "manager:DataSourcesCountModel:parse:badResponse"});
                }

            }
        });
    });

    return DataSourcesCountModel;
});
